import(/* webpackMode: "eager" */ "__barrel_optimize__?names=Spin!=!/www/wwwroot/quatang_client/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/quatang_client/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/quatang_client/node_modules/next/dist/client/link.js");
